import { Component, Input } from '@angular/core';
import { ProductDetail } from '../../generic/classes/product.detail';

@Component({
    selector: 'product-detail-features',
    templateUrl: 'productdetail.features.component.html',
    styleUrls: ['./productdetail.features.component.scss'],
    standalone: true,
})
export class ProductDetailFeaturesComponent {
    @Input() productDetail: ProductDetail;

    getFeatures(): string[] {
        const features: string[] = [];

        if (this.productDetail.features) {
            const featuresArray = this.productDetail.features.split(',');

            featuresArray.forEach(feature => {
                const trimmedFeature = feature.trim();
                features.push(trimmedFeature);
            });
        }

        return features;
    }
    hasFeatures(): boolean {
        return this.getFeatures().length > 0;
    }
}
